<template>
  <div id="app">
    <div class="widget-container flex justify-center">
      <router-view/>
    </div>
  </div>
</template>
<script>
export default {
}
</script>
<style lang="postcss">
.widget-container {
  @apply fl-sym-max-w-screen-sm fl-sym-mx-auto fl-sym-h-screen;
}
#app {
  max-height: 100vh;
  overflow-y: auto;
  position: relative;
}
.fl-sym .inline-block{
  @apply fl-sym-inline-block;
}
.fl-sym .mb-6{
  @apply fl-sym-mb-6;
}
.fl-sym .py-3{
  @apply fl-sym-py-3;
}
.fl-sym .px-4 {
  @apply fl-sym-px-4;
}
.fl-sym .rounded-lg {
  @apply fl-sym-rounded-lg;
}
.fl-sym .border {
  @apply fl-sym-border;
}
.fl-sym .shadow {
  @apply fl-sym-shadow;
}
.fl-sym .bg-blue {
  @apply fl-sym-bg-green-400;
}
.fl-sym .text-white {
  @apply fl-sym-text-white;
}
</style>